import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { Button } from './StyledButton';
import { styled } from '@mui/material/styles';
import { GoogleColoredIcon } from '../../Icons/GoogleColoredIcon';
import { CircularProgress } from '@mui/material';

const StyledGoogleButton = styled(Button)(({ theme }) => ({
	padding: theme.spacing(1.5),
	borderRadius: theme.shape.borderRadius,
	fontWeight: 500,
	textTransform: 'none',
	marginTop: theme.spacing(1),
	marginBottom: theme.spacing(1),
	color: theme.palette.text.primary,
	backgroundColor: theme.palette.background.paper,
	border: `1px solid ${theme.palette.divider}`,
	justifyContent: 'flex-start',
	'&:hover': {
		backgroundColor: theme.palette.action.hover
	}
}));

export const GoogleLoginButton = ({ loading, isTeacherLogin, text }) => {
	const [error, setError] = useState(null);

	const redirectUri =
		window.location.protocol === 'https:'
			? `https://app.admiterepolitie.ro${isTeacherLogin ? '/login/profesor' : '/login'}`
			: `http://localhost:3000${isTeacherLogin ? '/login/profesor' : '/login'}`;

	const login = useGoogleLogin({
		flow: 'auth-code',
		ux_mode: 'redirect',
		redirect_uri: redirectUri,
		onError: () => setError('Google login failed. Please check your popup settings.')
	});

	const buttonText = text ? text : 'Conectează-te cu Google';

	return (
		<>
			<StyledGoogleButton
				fullWidth
				startIcon={<GoogleColoredIcon sx={{ fontSize: 20 }} />}
				onClick={login}
				disabled={loading}
			>
				{loading ? <CircularProgress size={24} color="inherit" /> : buttonText}
			</StyledGoogleButton>

			{error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
		</>
	);
};
